import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {CARD_NUMBER_MAX_LENGTH, CARD_NUMBER_MIN_LENGTH} from '../domain/constants';

const CARD_NUMBER_LENGTH = 16;
const LUHN_MOD = 10;
const LUHN_DOUBLED_OVERFLOW = 9;
const DIGITS_ONLY_PATTERN = /^\d+$/;
const CARD_MASK_PATTERN = /^\d{6}\D{6}\d{4}$/;

function isValidCardNumber(value: string): boolean {
    if (!value || value.length !== CARD_NUMBER_LENGTH || !DIGITS_ONLY_PATTERN.test(value)) {
        return false;
    }
    const sum = [...value].reverse().reduce((acc, char, index) => {
        const digit = Number(char);
        if (index % 2 === 0) {
            return acc + digit;
        }
        return acc + (digit * 2 > LUHN_DOUBLED_OVERFLOW ? digit * 2 - LUHN_DOUBLED_OVERFLOW : digit * 2);
    }, 0);
    return sum % LUHN_MOD === 0;
}

function isValidCardMask(value: string): boolean {
    return CARD_MASK_PATTERN.test(value);
}

export function cardNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const digits = value.replace(/\s+/g, '');
        if (isValidCardMask(digits)) {
            return null;
        }
        const errors: ValidationErrors = {};
        if (digits.startsWith('0')) {
            errors.invalidCard = true;
        }
        if (digits.length < CARD_NUMBER_MIN_LENGTH) {
            errors.minlength = {requiredLength: CARD_NUMBER_MIN_LENGTH, actualLength: digits.length};
        } else if (digits.length > CARD_NUMBER_MAX_LENGTH) {
            errors.maxlength = {requiredLength: CARD_NUMBER_MAX_LENGTH, actualLength: digits.length};
        } else if (!isValidCardNumber(digits)) {
            errors.invalidCard = true;
        }
        return Object.keys(errors).length > 0 ? errors : null;
    };
}
